module.exports = __webpack_public_path__ + "static/media/contract.f34a230b.svg";